const note = {
    version: '1.0.0',
    date: '2026-08-03',
    tags: ['Nyt'],
    body: `
- **Log ind med Microsoft.** Admin dashboardet bruger nu det samme Microsoft-login som kalenderen. Zoho-login er væk.
`,
};

export default note;
